import React from 'react';
import styles from './DemographicComparison.module.css';

const DemographicComparison = ({ comparison }) => (
  <div className={styles.DemographicComparison}>
    <h3 className={styles.Title}>vs. Your Demographic</h3>
    <p className={styles.Subtitle}>Your max lift vs peers</p>
    {comparison.map(c => (
      <div key={c.lift} className={styles.Row}>
        <div className={styles.RowHeader}>
          <span className={styles.LiftName}>{c.lift}</span>
          <span className={styles.MemberWeight}>
            {c.member_weight != null ? `${c.member_weight} lbs` : '-'}
          </span>
        </div>
        {c.n > 0 && (
          <div className={styles.Percentiles}>
            <span>P25: {c.p25} lbs</span>
            <span>Median: {c.p50} lbs</span>
            <span>P75: {c.p75} lbs</span>
          </div>
        )}
      </div>
    ))}
  </div>
);

export default DemographicComparison;
